//
//
//
//
//
//

import ListMixin from "../ListMixin";
import {provide as RegistrableProvide} from "../../../mixins/Registrable";
import TogglesChildren from "../../../mixins/TogglesChildren";

export default {
    name: "NavList",

    mixins: [ListMixin, RegistrableProvide('navList'), TogglesChildren]

}
